<main>
  <h1>Privacy policy</h1>
  <p>Last updated: May 1, 2022</p>
  
  <p>All the data that you enter on this website stays on your phone itself. We do not collect or transmit any data to our server.</p>
</main>

<style>
  * {
		font-family: 'Inter';
	}

  main {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 10px 10px 0;
	}
</style>